import { useEffect, useState } from 'react';

import SelectMui, { SelectChangeEvent } from '@mui/material/Select';
import { Typography, Box, MenuItem, FormControl } from '@mui/material';

type Params = {
    label?: string;
    placeholder?: string;
    itemSelected?: ParamsSelected;
    listItems: Array<ParamsSelected>;
    onChangeSelected?: (ParamsSelected: ParamsSelected) => void;
    disabled?: boolean;
    error?: boolean;
    textError?: string;
}

type ParamsSelected = {
    text: string;
    value: string;
}

const Select = ({ placeholder, itemSelected = { text: '', value: '' }, listItems, disabled = false, error = false, onChangeSelected, label, textError }: Params) => {
    const [select, setSelect] = useState<ParamsSelected>(itemSelected);

    const handleChange = (event: SelectChangeEvent) => {
        const selected = listItems?.find(({ value }) => value === event.target.value);

        if (selected) {
            setSelect(selected);
            onChangeSelected && onChangeSelected(selected);
        }
    };

    useEffect(() => {
        itemSelected && setSelect(itemSelected);
    }, [itemSelected]);

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            textAlign: 'start',
            flexDirection: 'column',
        }}>
            {label &&
                <Typography variant="caption" margin={0} paddingBottom={1}>
                    {label}
                </Typography>
            }
            <FormControl fullWidth disabled={disabled}>
                <SelectMui
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={select.value}
                    displayEmpty
                    onChange={handleChange}
                    sx={{
                        lineHeight: 1,
                        fontWeight: 400,
                        fontSize: '1rem',
                        height: {
                            xs: '2.8125rem',
                            md: '2.5rem',
                            lg: '2.8175rem'
                        },
                        borderRadius: '5px',
                        color: 'primary.main',
                        backgroundColor: 'white',
                        border: error ? '2px solid #FF0000' : '2px solid #8D9BB5',
                        '&:hover': {
                            borderColor: 'primary.main'
                        },
                        '#demo-simple-select': {
                            height: '100%',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0 0 0 .8rem',

                            '&.Mui-disabled': {
                                maxWidth: '100%',
                                backgroundColor: '#E0E3E6',
                                WebkitTextFillColor: '#8D9BB5'
                            }
                        },
                        'fieldset': {
                            borderWidth: '0px !important',
                        },
                        '&.Mui-disabled': {
                            border: 'none',
                        }
                    }}
                >
                    {placeholder &&
                        <MenuItem disabled value="">
                            {placeholder}
                        </MenuItem>
                    }
                    {listItems.map(({ value, text }, index) => <MenuItem key={index} value={value}>{text}</MenuItem>)}
                </SelectMui>
            </FormControl>
            {textError && <Typography variant='overline'>Campo obrigatorio!</Typography>}
        </Box >
    );
}

export default Select;